export const BOOKING_URL = "https://www.vagaro.com/luxveritaeskinspa/book-now";
export const GIFT_URL = "https://www.vagaro.com/luxveritaeskinspa";
export const PACKAGES_URL = "https://www.vagaro.com/luxveritaeskinspa";
export const CHERRY_URL = "https://pay.withcherry.com/lux-veritae--llc-?utm_source=merchant&utm_medium=qr_code_estimate&utm_campaign=v1";
export const PHONE_DISPLAY = "(602) 886-3652";
export const PHONE_TEL = "+16028863652";
export const FAX_DISPLAY = "(602) 483-1635";
export const EMAIL = "hello@luxveritae.com";
export const ADDRESS_LINE1 = "7316 E Stetson Dr., Ste. 12";
export const ADDRESS_LINE2 = "Scottsdale, AZ 85251";
export const MAPS_URL = "https://www.google.com/maps/search/?api=1&query=7316+E+Stetson+Dr+Ste+12+Scottsdale+AZ+85251";
export const HOURS = "Mon–Fri 10am–8pm · Sat 8am–8pm · Sun Closed";
export const DEPOSIT = "$50";
export const LOCATION = "Scottsdale, Arizona";
export const SOCIAL = [
  { id: "facebook", label: "Facebook", href: "https://www.facebook.com/people/Lux-Veritae-Skin-Spa/61582553904518/" },
  { id: "instagram", label: "Instagram", href: "https://www.instagram.com/luxveritaeskin/" },
  { id: "tiktok", label: "TikTok", href: "https://www.tiktok.com/@luxveritaeskin" },
  { id: "youtube", label: "YouTube", href: "https://www.youtube.com/@LuxVeritaeSkin" },
];
export const LOGO_URL =
  "https://customer-assets-0z36b82j.emergentagent.net/job_9be45afb-0ff3-466f-87e2-c78f44522464/artifacts/10540e027c6f7ec4_0507F39B-B3AC-442F-B3C9-341AAC283309.png";

const u = (id) =>
  `https://images.unsplash.com/${id}?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1800`;

export const IMG = {
  hero: u("photo-1570172619644-dfd03ed5d881"),
  laser: u("photo-1700760933574-9f0f4ea9aa3b"),
  skincare: u("photo-1731514771613-991a02407132"),
  peel: u("photo-1761718210089-ba3bb5ccb54f"),
  injectables: u("photo-1746017062285-13c77e29fc25"),
  weight: u("photo-1552693673-1bf958298935"),
  pmu: u("photo-1698335107935-e2c8287c4947"),
  waxing: u("photo-1787651343620-8d5303006ecb"),
  consult: u("photo-1629909614456-6b1c5c94cecc"),
  interior: u("photo-1714924674541-9e11b2d1dd1d"),
  room: u("photo-1787651343496-35b3666dd7d2"),
  portrait: u("photo-1506863530036-1efeddceb993"),
  portrait2: u("photo-1674932668403-33398b81c92f"),
  museGlow: "/brand/muse-glow.jpg",
  museHands: "/brand/muse-hands.jpg",
  museNeck: "/brand/muse-neck.jpg",
  rfMicroneedling: "/brand/rf-treatment.jpg",
  waxingArt: "/brand/art-waxing.jpg",
  weightTape: "/brand/art-weight-tape.jpg",
  weightConsult: "/brand/art-weight-consult.jpg",
  bookOnline: "/brand/art-book-online.jpg",
  membershipsArt: "/brand/art-memberships.jpg",
  giftArt: "/brand/art-gift.jpg",
  financingArt: "/brand/art-financing.jpg",
  serum: "/brand/art-serum.jpg",
  jawline: "/brand/art-jawline.jpg",
  brows: "/brand/art-brows.jpg",
  products: u("photo-1598528738936-c50861cc75a9"),
  desert: u("photo-1783211645687-a88d729a2121"),
  patio: u("photo-1783211645463-72e7cc607d3e"),
};

export const BEFORE_AFTER = [
  { treatment: "Glass Skin Laser (MultiFrax)", sessions: "Acne scarring · After 2 sessions", before: "/results/multifrax-before.jpg", after: "/results/multifrax-after.jpg", credit: "Image courtesy of MultiFrax · Dr. Shadrina, Milan" },
  { treatment: "Cosmelan® Chemical Peel", sessions: "Pigmentation · Cosmelan® method", before: "/results/cosmelan-before.jpg", after: "/results/cosmelan-after.jpg", credit: "Image courtesy of mesoestetic®" },
  { treatment: "RF Microneedling", sessions: "Pores, scarring & texture · Series of 3", before: "/results/rf-before.jpg", after: "/results/rf-after-v4.jpg", credit: "AI-generated illustration of typical results, not an actual client" },
];
